import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const event = gql`
  subscription WorkflowEntitySubscription {
    event: workflowEntityEvent {
      type
      entities {
        ...WorkflowEntity
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.entity.EntityRefs}
`;
